import { useCallback } from 'react';


export const useInputOnChange = (callback: (value: any) => void, needEvent: boolean) =>
    useCallback(e => callback(needEvent ? e : e.target.value), [callback, needEvent]);
